module.exports = __webpack_public_path__ + "static/img/img_form_1_zh.207863f4.png";